<template>
  <div class="detail">
    <div class="player" v-if="videoInfo">
      <myvideos :videoInfo="videoInfo" :paramsId="paramsId"></myvideos>
      <playlist
        :playList="playList"
        @getVideoInfo="getVideoInfo"
        v-model="preIndex"
      ></playlist>
    </div>
    <div class="errorPlay" @click="retry" v-else>
      <img src="../assets/loading.gif" alt="" />
      <p class="retry">视频加载失败,点击页面重试</p>
    </div>
  </div>
</template>
<script>
import myvideos from '../components/video/video.vue'
import playlist from '../components/playList/playlist.vue'
export default {
  data: () => ({
    volume: 30,
    videoInfo: {},
    preIndex: 0,
    // 视频id
    paramsId: {
      productId: null,
      productType: "3"
    },
    playList: []
  }),
  components: {
    myvideos,
    playlist
  },
  created () {
    // this.getPublicKey()
    this.paramsId.productId = this.$route.query.id
    const token = {
      'huashiToken': this.$route.query.huashiToken,
      'huashiLoginDevice': this.$route.query.huashiLoginDevice
    }
    localStorage.setItem('token', JSON.stringify(token))
    this.getVideoById()
  },
  methods: {
    // 点击重新加载
    retry () {
      this.$router.go(0)
    },
    // 根据id获取视频详情
    async getVideoById () {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      const res = await this.$http.getProduct(this.paramsId)
      loading.close();
      if (res.data.code === '0') {
        this.videoInfo = res.data.data
        console.log('videoInfo--',this.videoInfo)
        const productSeries = {}
        productSeries.productSeries = this.videoInfo.productSeries
        productSeries.productType = this.videoInfo.productType
        this.getFileUrl({
          fileName:this.videoInfo.productUrl
        })
        this.getProductionList(productSeries)
      } else {
        this.videoInfo = ''
        this.$message.error(res.data.msg)
      }
    },
        // 获取文件链接
    async getFileUrl (params) {
      console.log('getFileUrl-',params)
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      const res = await this.$http.getFileUrl(params)
      loading.close();
      if (res.data.code === '0') {
        console.log('getFileUrl---',res.data)
        console.log('getFileUrl--fileUrl-',res.data.data.fileUrl)
        this.videoInfo.productUrl =res.data.data.fileUrl
      } else {
        this.$message.error(res.data.msg)
      }
    },
    // 获取作品列表
    async getProductionList (params) {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      const res = await this.$http.getProductListWithLogin(params)
      loading.close();
      if (res.data.code === '0') {
        this.playList = res.data.data.list 
        console.log('this.playList--',this.playList)
        this.playList.forEach(item => {
          if (item.productId == this.$route.query.id) {
            this.preIndex = this.$route.query.id
          }
        })
      } else {
        this.$message.error(res.data.msg)
      }
    },
    getVideoInfo (params) {
      this.videoInfo = params
      this.playList.forEach(item => {
        if (item.productId == params.productId) {
          this.preIndex = params.productId
        }
      })
      this.$router.replace(`detail?id=${this.videoInfo.productId}`)
    },
    async getPublicKey () {
      const res = await this.$http.getPublicKey()
    }
  }
}
</script>
<style lang="scss" scoped>
.detail {
  display: flex;
  justify-content: space-between;
  padding: 56px 80px;
  .errorPlay {
    width: 100%;
    text-align: center;
  }
}
</style>